<template>
	<md-dialog :md-active="$route.name == 'editDeliveryVariant'" v-if="deliveryVariant" :md-click-outside-to-close=false :md-close-on-esc=false @md-clicked-outside="close" @keydown.esc="close">
		<md-dialog-title>Edit</md-dialog-title>
		<md-dialog-content>
			<div class="md-layout">
				<div class="md-layout-item">
					<md-field>
						<label for="name">Name</label>
						<md-input name="name" id="name" v-model="deliveryVariant.name" readonly required/>
					</md-field>
				</div>
			</div>
			<div class="md-layout">
				<div class="md-layout-item">
					<md-field>
						<label for="description">Description</label>
						<md-input name="description" id="description" v-model="deliveryVariant.description" />
					</md-field>
				</div>
			</div>
			<div class="md-layout">
				<div class="md-layout-item">
					<md-field>
						<label>Manifest fields</label>
						<md-select v-model="deliveryVariant.manifestFields" name="manifestFields" id="manifestFields" multiple>
							<md-option v-for="field in $store.getters.manifestFields" :key="field.id" :value="field.id">{{field.name}}</md-option>
						</md-select>
					</md-field>
				</div>
			</div>
			<div class="md-layout">
				<div class="md-layout-item">
				<md-chips v-model="deliveryVariant.tags" md-placeholder="Tags"></md-chips>
				</div>
			</div>
			<div class="md-layout">
				<div class="md-layout-item">
				<dialog-link-table :links="deliveryVariant.links"/>
				</div>
			</div>

			<md-progress-bar md-mode="indeterminate" v-if="sending" />
			<md-dialog-actions>
				<md-button class="md-primary" @click="close" :disabled="sending">Close</md-button>
			</md-dialog-actions>
		</md-dialog-content>
	</md-dialog>
</template>

<script>
import debounce from '../../mixins/debounce'
import DialogLinkTable from '../Common/DialogLinkTable.vue'

export default {
	name: 'Edit',
	components: { 'dialog-link-table': DialogLinkTable },
	data: () => ({
		sending: false,
		deliveryVariant: null
	}),
	mixins: [debounce],
	watch: {
		deliveryVariant: {
			deep: true,
			async handler() {
				await this.update()
			}
		}
	},
	created() {
		this.deliveryVariant = this.$store.getters.getDeliveryVariantById(this.$route.params.eid)
		this.deliveryVariant.manifestFields = this.deliveryVariant.manifestFields.map((mF) => mF.id)
		this.deliveryVariant.tags = this.deliveryVariant.tags.map((tag) => tag.tag)
		this.update = this.debounce(this.update)
	},
	methods: {
		async updateDeliveryVariant() {
			this.sending = true
			try {
				const tagIds = await this.$apiService.createTagsIfNotExist(this.deliveryVariant.tags)
				await this.$apiService.deliveryVariant.update(this.deliveryVariant.id, {
					description: this.deliveryVariant.description,
					tagIds,
					links: this.deliveryVariant.links,
					manifestFieldIds: this.deliveryVariant.manifestFields
				})
			} catch (e) {
				this.$snackbar.showMessage(e)
			}
			this.sending = false
		},
		async update() {
			await this.updateDeliveryVariant()
		},
		async close() {
			try {
				await this.$store.dispatch('loadDeliveryVariants', { sortBy: this.sortBy, sortOrder: this.sortOrder })
			} catch (e) {
				this.$snackbar.showMessage(e)
			}
			this.$router.back()
		}
	}
}
</script>

<style scoped>
.info {
	margin-left: 20px
}
</style>
